import { inject, Injectable } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import {
  EditContactModalComponent,
  IEditContactModalResult
} from "@shared/components/contacts/edit-contact-modal/edit-contact-modal.component";

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  modalService = inject(NgbModal);

  public openEditContactModal(options: NgbModalOptions = { size: 'sm' }): {
    result: Promise<IEditContactModalResult>,
    instance: EditContactModalComponent
  } {
    const modalRef = this.modalService.open(EditContactModalComponent, options);
    return {
      result: modalRef.result as Promise<IEditContactModalResult>,
      instance: modalRef.componentInstance as EditContactModalComponent
    };
  }
}
